import light_word from 'assets/images/webda/light-word.png';
import light_unknown from 'assets/images/webda/light-unknown.png';
import light_sound from 'assets/images/webda/light-sound.png';
import light_film from 'assets/images/webda/light-film.png';
import light_zip from 'assets/images/webda/light-zip.png';
import light_photo from 'assets/images/webda/light-photo.png';
import light_folder from 'assets/images/webda/light-folder.png';
import light_survey from 'assets/images/webda/light-survey.png';
import light_chart from 'assets/images/webda/light-chart.png';
import light_image from 'assets/images/webda/light-photo.png';

import dark_word from 'assets/images/webda/dark-word.png';
import dark_unknown from 'assets/images/webda/dark-unknown.png';
import dark_sound from 'assets/images/webda/dark-sound.png';
import dark_film from 'assets/images/webda/dark-film.png';
import dark_zip from 'assets/images/webda/dark-zip.png';
import dark_photo from 'assets/images/webda/dark-photo.png';
import dark_folder from 'assets/images/webda/dark-folder.png';
import dark_survey from 'assets/images/webda/dark-survey.png';
import dark_chart from 'assets/images/webda/dark-chart.png';
import dark_image from 'assets/images/webda/dark-photo.png';

import user from 'assets/images/user.svg';

import balin from 'assets/images/provider/ic-balin.png';
import vaccin from 'assets/images/provider/ic-vaccin.png';
import clinic from 'assets/images/provider/ic-clinic.png';
import doctor from 'assets/images/provider/ic-doctor.png';
import health from 'assets/images/provider/ic-health.png';
import consult from 'assets/images/provider/ic-consult.png';
import hospital from 'assets/images/provider/ic-hospital.png';
import lab from 'assets/images/provider/ic-lab.png';
import { StringOrNull } from 'store/entity/types';
import { IProviderItemView } from 'store/providers/providerTypes';

export const itemImageLight = {
  word: light_word,
  unknown: light_unknown,
  sound: light_sound,
  report: light_chart,
  film: light_film,
  zip: light_zip,
  picture: light_photo,
  folder: light_folder,
  profile: user,
  survey: light_survey,
};

export const itemImageDark = {
  word: dark_word,
  unknown: dark_unknown,
  sound: dark_sound,
  report: dark_chart,
  film: dark_film,
  zip: dark_zip,
  picture: dark_photo,
  folder: dark_folder,
  profile: user,
  survey: dark_survey,
};

export const providerIconLight = {
  بیمارستان: hospital,
  درمانگاه: clinic,
  تصویر: light_image,
  آزمایشگاه: lab,
  پزشک: doctor,
  واکسیناسیون: vaccin,
  بالینی: balin,
  مشاوره: consult,
  سلامت: health,
};

export const providerIconDark = {
  بیمارستان: hospital,
  درمانگاه: clinic,
  تصویر: dark_image,
  آزمایشگاه: lab,
  پزشک: doctor,
  واکسیناسیون: vaccin,
  بالینی: balin,
  مشاوره: consult,
  سلامت: health,
};

const images = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/svg+xml',
  'image/webp',
  'image/vnd.adobe.photoshop',
  'image/x-bmp',
  'image/bmp',
];

const whiteListedImages = [
  'image/png',
  'image/jpeg',
  'image/svg+xml',
  'image/webp',
  'image/x-bmp',
  'image/bmp',
];

const compressed = [
  'application/zip',
  // 'application/gzip',
  // 'application/vnd.rar',
  // 'application/x-tar',
  // 'application/x-7z-compressed',
  'application/x-zip-compressed',
  // 'application/x-rar-compressed',
  // 'application/x-bzip2',
  // 'application/x-rar',
  // '*/*',
  // '',
];

const document = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.presentation',
  'text/plain',
  'text/csv',
  'application/epub+zip',
];

const video = [
  'video/3gpp',
  'audio/3gpp',
  'video/ogg',
  'video/quicktime',
  'video/x-matroska',
  'audio/x-matroska',
  'video/webm',
  'audio/webm',
  'video/vnd.avi',
  'video/avi',
  'video/msvideo',
  'video/x-msvideo',
  'video/x-flv',
  'video/mp4',
  'audio/mp4',
];

const audio = [
  'audio/mpeg',
  'audio/MPA',
  'audio/mpa-robust',
  'audio/flac',
  'audio/vnd.wave',
  'audio/wav',
  'audio/wave',
  'audio/x-wav',
  'audio/mp3',
];

export const getValidFormats: { [key: string]: string[] } = {
  image: images,
  audio,
  video,
  document,
  compressed,
};

export const isImage = (fileType: any) => {
  return images.includes(fileType);
};
export const iconSelector = (fileType: any, isLight: boolean = true) => {
  const image = isLight ? itemImageLight : itemImageDark;
  if (images.includes(fileType)) {
    return image.picture;
  } else if (compressed.includes(fileType)) {
    return image.zip;
  } else if (document.includes(fileType)) {
    return image.word;
  } else if (video.includes(fileType)) {
    return image.film;
  } else if (audio.includes(fileType)) {
    return image.sound;
  } else {
    return image.unknown;
  }
};

function getProviderIcon(
  name: StringOrNull | undefined,
  workingContext: string | undefined
) {
  for (const [key, value] of Object.entries(providerIconLight)) {
    if (workingContext?.includes(key) || name?.includes(key)) {
      return value;
    }
  }
  return itemImageLight.profile;
}

export const itemIconSelector = (item: IProviderItemView, isLight = true) => {
  const image = isLight ? itemImageLight : itemImageDark;
  if (item.type === 'document')
    return iconSelector(item.document.properties.format);
  else if (item.type === 'folder') {
    return image.folder;
  } else if (item.type === 'link') {
    return getProviderIcon(item.name, (item as any).workingContext);
  } else if (item.type === 'survey') {
    return image.survey;
  } else if (item.type === 'quill') {
    return image.word;
  } else if (item.type === 'surveyReport') {
    return image.report;
  } else return image.unknown;
};

export const isInWhiteList = (fileType: any) => {
  const whiteList = [
    ...video,
    ...audio,
    ...whiteListedImages,
    'application/pdf',
  ];
  return whiteList.includes(fileType);
};
